import { useState } from "react"
import { Stack } from "@mui/material";
import StudySelection from "./StudySelection";
import ReleaseSelection from "./ReleaseSelection";
import DatasetSelection from "./DatasetSelection";
import FileSelection from "./FileSelection";
import DownloadDetails from "./DownloadDetails";
import DownloadFull from "./DownloadFull";
import Continue from "./Continue";

export enum DownloadProcessSteps {
    StudySelection = 1,
    ReleaseSelection = 2,
    DatasetSelection = 3,
    FileSelection = 4,
    DownloadDetails = 5,
} 
export const stepLabels = [
    "STUDY SELECTION",
    "RELEASE SELECTION",
    "DATASET SELECTION",
    "FILE SELECTION",
    "DOWNLOAD DETAILS"
];

const DataDownloadProcess = () => {
    const [curStep, setCurStep] = useState(DownloadProcessSteps.StudySelection);
    const [infoScreen, setInfoScreen] = useState(true)
    const [info, setInfo] = useState({
        study: "",
        release: "",
        dataset: "",
        selected: new Set()    
    })
    const [full, setFull] = useState(false)

    const renderStepComponent = () => {
        if(infoScreen){
            return <Continue
                setInfoScreen={setInfoScreen}/>
        }
        switch (curStep) {
        case DownloadProcessSteps.StudySelection: {
            return (<StudySelection
                setCurStep={setCurStep}
                info={info}
                setInfo={setInfo}
                setInfoScreen={setInfoScreen}/>)
        }

        case DownloadProcessSteps.ReleaseSelection: {
            return (<ReleaseSelection 
                setCurStep={setCurStep}
                info={info}
                setInfo={setInfo}/>)
        }

        case DownloadProcessSteps.DatasetSelection: {
            return (<DatasetSelection
                setCurStep={setCurStep}
                info={info}
                setInfo={setInfo}
                setFull={setFull}/>)
        }

        case DownloadProcessSteps.FileSelection: {
            return (<FileSelection
                setCurStep={setCurStep}
                info={info}
                setInfo={setInfo}/>

            )
        }

        case DownloadProcessSteps.DownloadDetails: {
            if(full){
                return (<DownloadFull
                    setCurStep={setCurStep}
                    info={info}
                    setInfo={setInfo}/>)
            }
            else{
                return (<DownloadDetails
                    setCurStep={setCurStep}
                    info={info}
                    setInfo={setInfo}/>
    
                )
            }
        }
        }
    }

    return (
        <Stack flexDirection="column" gap={4} height="100%" marginX="50px">
            {renderStepComponent()}
        </Stack>
    )
}

export default DataDownloadProcess